import { createStyles } from 'antd-style'

export const useStyle = createStyles({
  dashboardCard: {
    maxHeight: 375
  }
})
